{
  "campaignName": "Tangent Points",
  "platform": "Tangent",
  "description": "Points for providing liquidity.",
  "platformImageId": "tangent.png",
  "dashboardLink": "https://app.tangent.finance/predeposit/",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x97ba10115da528c113462ede9c20d7adc806d93f",
      "network": "ethereum",
      "multiplier": "tangent points",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xefc056790bb19702b2164ec6ea6ba3ae01d81195",
      "network": "ethereum",
      "multiplier": "tangent points",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x317837aed98bea887074d1f97fd3c83ebca6905b",
      "network": "ethereum",
      "multiplier": "tangent points",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xC6ac08424eE6D1373F03611b96f5Da849594B6D8",
      "network": "ethereum",
      "multiplier": "tangent points",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
